/**
 * Created by mh on 2017/5/24.
 */
import React from 'react';
import PropTypes from 'prop-types';
import { observer, inject } from 'mobx-react';
import { injectIntl } from 'react-intl';

import { Switch, Redirect, Route } from 'react-router-dom';

import NavigationLeftAssetsComponent from './NavigationLeftAssets';
import AssetsComponent from './Assets';
import AssetDetailsComponent from './AssetDetails';

import PrivateRoute from '../PrivateRoute.jsx';

@inject('auth') @observer
class AppAssets extends React.Component {
    render() {
        if (this.props.auth) {
            console.log('Authentication isLoggedIn', this.props.auth.isLoggedIn, this.props.auth.isLoggingIn);
        } else {
            console.log('Authentication not set yet.');
        }
        const { match } = this.props;
        return (
            <div className="row">
                <NavigationLeftAssetsComponent />

                <main className="col-sm-9 ml-sm-auto col-md-10 pt-3" role="main">
                    <Switch>
                        <PrivateRoute exact path={`${match.path}/`} component={AssetsComponent} />
                        <PrivateRoute exact path={`${match.path}/:page`} component={AssetsComponent} />
                        <PrivateRoute exact path={`${match.path}/type/:type`} component={AssetsComponent} />
                        <PrivateRoute exact path={`${match.path}/type/:type/:page`} component={AssetsComponent} />
                        <PrivateRoute path={`${match.path}/details/:id/`} component={AssetDetailsComponent} />
                        <Route render={() => <Redirect to={`${match.path}/`} />} />
                    </Switch>
                </main>
            </div>
        );
    }
}

// TODO why not wrappedComponent ?
AppAssets.propTypes = {
    match: PropTypes.object.isRequired,
};

export default injectIntl(AppAssets);

